import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-primary-100 rounded-full mb-6">
            <Icon name="ChefHat" size={48} className="text-primary" />
          </div>
          <h1 className="font-headline text-6xl font-bold text-primary mb-4">404</h1>
          <h2 className="font-headline text-2xl font-semibold text-text-primary mb-4">
            Page Not Found
          </h2>
          <p className="text-text-secondary mb-8">
            Looks like this page wandered off the menu! Let's get you back to the delicious content.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/homepage-mediterranean-restaurant-experience"
            className="btn-primary w-full inline-flex items-center justify-center space-x-2"
          >
            <Icon name="Home" size={20} />
            <span>Back to Home</span>
          </Link>
          
          <Link
            to="/interactive-menu-culinary-discovery"
            className="btn-conversion w-full inline-flex items-center justify-center space-x-2"
          >
            <Icon name="ChefHat" size={20} />
            <span>View Our Menu</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;